import styled from "styled-components";
import {Sidebar} from "../../../components/Sidebar";
import {NavHeader} from "../../../components/NavHeader";
import {CreateOrderForm} from "../../../components/CreateOrderForm";
import AppLayout from "../../../layouts/AdminLayout";

export const CreateOrder = () => {
  return (
    <AppLayout>
        {/* <NavHeader title="" /> */}
        <CreateOrderForm />
    </AppLayout>
  );
};